<template>
  <header class="header">
    <a class="logo" href="https://www.nike.com/au/en_gb/" aria-label="Nike.com home" title="Click to go to Nike.com home">
      <Swoosh class="icon-logo" />
      <p class="logo__caption"><strong>Shop Nike Stores</strong></p>
    </a>
  </header>
</template>

<script>
// @ is an alias to /src
import Swoosh from '@/assets/icons/swoosh.svg';

export default {
  name: 'Header',
  components: {
    Swoosh,
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import "@/assets/scss/settings.scss";

  $header-height-s: 84px;
  $header-height: 104px;
  $logo-width: 60px;

  .header {
    display: flex;
    height: $header-height-s;
    align-items: center;
    justify-content: center;

    @include medium-up {
      height: $header-height;
    }
  }

  .logo {
    display: block;
    text-decoration: none;
    text-align: center;

    &:hover,
    &:focus {
      color: $body-text;
    }
  }

  .icon-logo {
    width: $logo-width;
    height: auto;
  }

  .logo__caption {
    font-size: 20px;
    line-height: 1;
    font-weight: 700;
  }
</style>
